// extracted by mini-css-extract-plugin
export var leftAlign = "_2x-2";
export var popper = "_2x-0";
export var subtitle = "_2x-1";